import { constants } from "redux/constants/redux-constants";

export const setSearchKeyword = (keyword, context) => ({
    type: constants.SET_SEARCH_KEYWORD,
    payload: { keyword, context },
  });